import { gql } from "@grandvisionhq/graphql";
const mergeShoppinglistFailureFragment = gql`
  fragment MergeShoppinglistFailureFragment on ShoppinglistsMergeFailure {
    ... on ShoppinglistAuthorizationFailure {
      message
    }
    ... on ShoppinglistFailure {
      message
    }
    ... on ShoppinglistNotFoundFailure {
      message
    }
    ... on ShoppinglistValidationFailure {
      message
    }
  }
`;
const MERGE_SHOPPING_LISTS = gql`
  mutation MergeShoppinglists($input: MergeShoppinglistsInput!) {
    mergeShoppinglists(input: $input) {
      shoppinglist {
        id
      }
      failure {
        ...MergeShoppinglistFailureFragment
      }
    }
  }
  ${mergeShoppinglistFailureFragment}
`;
export {
  MERGE_SHOPPING_LISTS as default
};
//# sourceMappingURL=merge-shopping-lists.js.map
